var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollar = function SvgDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 10 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.942 17.434v-2.082q-1.411-.29-2.438-1.114Q.478 13.414 0 11.913l1.971-.726q.4 1.163 1.186 1.767.786.606 2.064.606 1.092 0 1.852-.449.76-.448.758-1.392 0-.846-.586-1.343-.585-.495-2.717-1.126-2.29-.654-3.143-1.563T.533 5.472q0-1.574 1.118-2.445 1.12-.871 2.291-.993V0h2.131v2.034q1.332.195 2.198.884.867.69 1.265 1.683l-1.971.774q-.32-.774-.906-1.162-.585-.387-1.598-.387-1.171 0-1.785.472-.612.474-.612 1.174 0 .8.799 1.26.8.46 2.77.968 1.838.485 2.784 1.538.947 1.054.945 2.433 0 1.72-1.118 2.615-1.12.896-2.77 1.114v2.034z"
  })));
};
export default SvgDollar;